import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Premium Modern Palette
const lightTheme = {
  dark: false,
  colors: {
    background: '#F8FAFC',
    surface: '#FFFFFF',
    primary: '#4F46E5', // Indigo 600
    'primary-darken-1': '#4338CA',
    secondary: '#8B5CF6', // Violet 500
    'secondary-darken-1': '#7C3AED',
    accent: '#06B6D4', // Cyan 500
    error: '#EF4444',
    info: '#3B82F6',
    success: '#10B981',
    warning: '#F59E0B',
    'on-background': '#0F172A',
    'on-surface': '#1E293B',
  }
}

const darkTheme = {
  dark: true,
  colors: {
    background: '#0F172A', // Slate 900
    surface: '#1E293B', // Slate 800
    primary: '#6366F1', // Indigo 500
    'primary-darken-1': '#4F46E5',
    secondary: '#A78BFA', // Violet 400
    'secondary-darken-1': '#8B5CF6',
    accent: '#22D3EE', // Cyan 400
    error: '#F87171',
    info: '#60A5FA',
    success: '#34D399',
    warning: '#FBBF24',
    'on-background': '#F8FAFC',
    'on-surface': '#F1F5F9',
  }
}

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  },
  theme: {
    defaultTheme: (typeof window !== 'undefined' && localStorage.getItem('inquiry-theme')) || 'dark',
    variations: {
      colors: ['primary', 'secondary', 'surface'],
      lighten: 3,
      darken: 3,
    },
    themes: {
      light: lightTheme,
      dark: darkTheme,
    }
  },
  defaults: {
    VBtn: {
      variant: 'flat',
      height: 44,
      rounded: 'lg',
      class: 'text-none font-weight-bold letter-spacing-normal'
    },
    VCard: {
      elevation: 0,
      border: true,
      rounded: 'xl'
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
      hideDetails: 'auto'
    },
    VTextarea: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
      hideDetails: 'auto'
    }
  }
})
